const init = () => {

    /* response shape:
    [
        {
            name: 'Author Name',
            link: 'http://'
        }
    ]
    */
    
    var $component = $('.c-author-listing');
    if (!$component.length) return;
    var $alphabet = $component.find('.c-author-listing__alphabet');
    var $results = $component.find('.c-author-listing__results');
    var response;

    // Handle window resize directly
    $(window).on('resize', _.debounce(function() {
        if (response) replaceResults(chunkResults(response));
    }, 250));

    $alphabet.on('click', 'button', function() {
        var $selected = $(this);
        if ($selected.hasClass('is-selected')) {
            $component.addClass('is-collapsed');
            $selected.removeClass('is-selected');
            $selected.blur();
            return;
        }
        
        $alphabet.find('button').removeClass('is-selected');
        $selected.addClass('is-selected');
        var data = {
            letter: $selected.text().toLowerCase()
        }

        $.getJSON(window.siteUrl + 'api/authors', data)
            .done(function(data, textStatus, jqXhr) {
                response = data;
                replaceResults(chunkResults(data));
                $component.removeClass('is-collapsed');
            })
            .fail(function() {
                logger.info('fail');

                // TESTING
                if (app.state.debug) {
                    var data = [];
                    for (var i=0, len=24; i<=len; i++) {
                        data.push({
                            name: 'Firstname Lastname ' + i,
                            link: '#'
                        })
                    }
                    response = data;
                    replaceResults(chunkResults(data));
                }
            });
    });

    /**
     * @description splits array of authors into columns
     * @param {Object[]} data - authors
     * @returns {Array} columns
     */
    function chunkResults(data) {

        var authorChunks;
        switch(im.getActive()) {
            case 'phone':
                // 1 col
                authorChunks = [data];
            break;
            case 'tablet':
                // 2 cols

                // column bounds
                var len = data.length;
                var chunk1 = Math.ceil(len / 2);
                var chunk2 = Math.ceil(len / 2 * 2);

                // data -> columns
                var authorChunks = [
                    data.slice(0, chunk1),
                    data.slice(chunk1, len)
                ];
            break;
            case 'tablet-landscape':
            case 'desktop':
            case 'widescreen':
                // 3 cols

                // column bounds
                var len = data.length;
                var chunk1 = Math.ceil(len / 3);
                var chunk2 = Math.ceil(len / 3 * 2);

                // data -> columns
                var authorChunks = [
                    data.slice(0, chunk1),
                    data.slice(chunk1,chunk2),
                    data.slice(chunk2, len)
                ];
            break;
        }

        var authorColumns = _.map(authorChunks, function(column, i) {
            return _.map(column, function(author, j) {
                var wrapper = document.createElement('li');
                var el = document.createElement('a');
                el.href = author.link;
                el.innerText = author.name;
                wrapper.appendChild(el);
                return wrapper;
            });
        });
        return authorColumns;
    }

    /**
     * @description adds columns to dom
     * @param {Array} columnData - author nodes
     */
    function replaceResults(columnData) {
        var $columns = [];
        _.each(columnData, function(el, i) {
            var $column = $('<ul>', {
                class: 'c-author-listing__results-column'
            });
            $column.append(el);
            $columns.push($column);
        });
        $results.html($columns);
    }

}

export default init;
